"use client";
import { useState } from "react";
import { FormProvider } from "../bLocationForm/formContext";
import ContactFormStep1 from "../bLocationForm/contactFormStep1";
import ContactFormStep2 from "../bLocationForm/contactFormStep2";




const BusinessLoanPagesForm = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [step2, setStep2] = useState(false);
  const [showNextStep, setShowNextStep]= useState(false)

  const showSteps=()=>{
    setShowNextStep(true)
}
const showFirstStep=()=>{
  setShowNextStep(false)
}

  const showStep2=()=>{
    setStep2(true)
  }

  return (
    <div
    className={`${isHovered ?'rounded-[30px] sm:rounded-md':'rounded-[60px] sm:rounded-md'} absolute sm:relative left-0 right-0 mx-auto -mt-6 w-full max-w-[720px] bg-white shadow-lg transition-all duration-100 ease-in-out`}
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}>
      <div className="flex flex-wrap">
   
      <div className="flex w-[40%] sm:w-full  justify-between sm:py-1 sm:px-2 p-4 rounded-lg">
        <p className="font-semibold text-gray-700">
          Get hassle-free business loan within 48 hrs now
        </p>
        
      </div>
      
      <FormProvider>
      <div className="p-4 sm:py-1 sm:px-2 w-[60%] sm:w-full rounded-lg">
        {!showNextStep ?
          <ContactFormStep1 showStep1={showSteps} hovered={isHovered} />
        : 
        <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew"/>
        }
        
       
        
      </div>
      </FormProvider>
      </div>
    
  </div>
  );
};

export default BusinessLoanPagesForm;
